import { NotificationTypeEnum } from '@elearning-platform/api-types/enums';
import React from 'react';

import { ReactComponent as BronzeMedal } from '../../../../images/bronzeMedal.svg';
import { ReactComponent as CertificatesIcon } from '../../../../images/certificates.svg';
import { ReactComponent as CompetencesIcon } from '../../../../images/competences.svg';
import { ReactComponent as FormsIcon } from '../../../../images/forms.svg';
import { ReactComponent as GamificationIcon } from '../../../../images/gamification.svg';
import { ReactComponent as GoldMedal } from '../../../../images/goldMedal.svg';
import { ReactComponent as KnowledgeBaseIcon } from '../../../../images/knowledgeBase.svg';
import { ReactComponent as NewsIcon } from '../../../../images/news.svg';
import { ReactComponent as FallbackIcon } from '../../../../images/sales.svg';
import { ReactComponent as SilverMedal } from '../../../../images/silverMedal.svg';
import { ReactComponent as TrainingsIcon } from '../../../../images/trainings.svg';
import { NotificationLinkType } from '../../enums';
import { notificationLinkRegexp } from '../../regexps';

import { notificationLinkRoutes } from './notification.consts';

export const getIcon: (name: NotificationTypeEnum) => JSX.Element | undefined = (name: NotificationTypeEnum): JSX.Element | undefined => {
  switch (name) {
    case NotificationTypeEnum.NewCertificate:
      return <CertificatesIcon />;
    case NotificationTypeEnum.VerificationRejected:
    case NotificationTypeEnum.VerificationAccepted:
    case NotificationTypeEnum.SurveyShare:
      return <FormsIcon />;
    case NotificationTypeEnum.NewsNewComment:
    case NotificationTypeEnum.NewsNewLike:
    case NotificationTypeEnum.NewsNew:
      return <NewsIcon />;
    case NotificationTypeEnum.CompetenceConfirmationAccept:
    case NotificationTypeEnum.CompetenceConfirmationReject:
      return <CompetencesIcon />;
    case NotificationTypeEnum.EventEnroll:
      return <TrainingsIcon />;
    case NotificationTypeEnum.ContentExpire:
    case NotificationTypeEnum.ContentFinish:
      return <KnowledgeBaseIcon />;
    case NotificationTypeEnum.AwardGold:
      return <GoldMedal />;
    case NotificationTypeEnum.AwardSilver:
      return <SilverMedal />;
    case NotificationTypeEnum.AwardBronze:
      return <BronzeMedal />;
    case NotificationTypeEnum.GamificationTaskPassed:
    case NotificationTypeEnum.GamificationNewLevel:
    case NotificationTypeEnum.GamificationChallengeRemind:
    case NotificationTypeEnum.GamificationChallengeNew:
    case NotificationTypeEnum.AchievementReceived:
    case NotificationTypeEnum.GamificationNewsNew:
    case NotificationTypeEnum.GamificationNewsNewComment:
    case NotificationTypeEnum.GamificationNewsNewLike:
      return <GamificationIcon />;
    case NotificationTypeEnum.GamificationMeetingNew:
    case NotificationTypeEnum.GamificationChallengePassed:
      return <GamificationIcon />;
    case NotificationTypeEnum.EventDisenroll:
    case NotificationTypeEnum.EventInvite:
    case NotificationTypeEnum.EventThanks:
    case NotificationTypeEnum.GamificationNewsCommentToo:
    case NotificationTypeEnum.NewsCommentToo:
    case NotificationTypeEnum.WebinarCancel:
    case NotificationTypeEnum.WebinarCreated:
    case NotificationTypeEnum.WebinarEnroll:
    case NotificationTypeEnum.WebinarInvite:
    case NotificationTypeEnum.WebinarRemindPresenter:
    case NotificationTypeEnum.WebinarRemindViewer:
    case NotificationTypeEnum.WebinarThanks:
      return <FallbackIcon />;
    default:
      name satisfies never;

      return <FallbackIcon />;
  }
};

export const stripIndentation: (message: string) => string = (message: string): string => message.replace(/^[ \t]+/gm, '');

export const convertLinkTags: (message: string) => string = (message: string): string => message.replace(
  notificationLinkRegexp,
  (_: string, rawType: string, id: string, title: string): string => {
    const linkType: NotificationLinkType | undefined = Object.values(NotificationLinkType).find(
      (value: NotificationLinkType): boolean => value === `[link=${rawType}:`);

    if (linkType === undefined) {
      return title;
    }

    // TODO: temporary code specific for gamification until gamification id is handled
    const href: string = linkType === NotificationLinkType.Gamification
      ? notificationLinkRoutes[linkType]
      : `${notificationLinkRoutes[linkType]}${id}`;

    return `[${title}](${href})`;
  },
);
